/*
DO NOT MANUALLY TRANSLATE!
Follow the instructions in the README.md to conveniently update translations.
*/

export default {
  "CookieMessage.old.link": "Weitere Informationen",
  "CookieMessage.old.text":
    "Wir verwenden Cookies, um eine optimale Funktionsweise unseres Webshops zu gewährleisten. Lesen Sie unsere Cookie-Richtlinien.",
  "CookieMessage.link": "Prijať cookies",
  "CookieMessage.more_information":
    "Prečítajte si viac o súboroch cookie spoločnosti Kramp",
  "CookieMessage.return": "Späť",
  "CookieMessage.intro.body":
    '\nTieto súbory cookie boli umiestnené spoločnosťou Kramp i tretími stranami. Je pre nás samozrejmosťou, že sa pri tom staráme o Vaše súkromie. Ak nižšie kliknete na tlačidlo "Prijať súbory cookie", vyjadrujete súhlas s ich používaním. Prijatím týchto súborov cookie zaistíte správne fungovanie nášho webu. Príklady toho, na čo sa používajú:',
  "CookieMessage.intro.list.1": "Automatické prihlásenie do časti Môj účet",
  "CookieMessage.intro.list.2":
    "Analýza správania návštevníkov kvôli zlepšeniu webu",
  "CookieMessage.intro.list.3":
    "Vytvorenie zákazníckych profilov, ktoré nám umožnia ponúkať prispôsobené ponuky a reklamy",
  "CookieMessage.intro.extra":
    'Ak nechcete prijať všetky súbory cookie, môžete to zmeniť v <a>nastaveniach</a>. Ďalšie informácie získate v našom <a href="{legalLink}">vyhlásení o ochrane osobných údajov a súboroch cookie.</a>',
  "CookieMessage.intro.title": "Spoločnosť Kramp používa súbory cookie",
  "CookieMessage.settings.body":
    'Môžete si vybrať z troch nastavení súborov cookie. Výber možnosti "Štandardné" nám umožní poskytnúť Vám najlepší zážitok z webu.',
  "CookieMessage.settings.standard.title": "Štandardné (najpopulárnejšie)",
  "CookieMessage.settings.standard.body":
    "Súbory cookie používané na prihlásenie, objednávanie, prispôsobené ponuky, sociálne médiá a súbory cookie ďalších strán v rámci aj mimo Európy.",
  "CookieMessage.settings.restricted.title": "Obmedzené",
  "CookieMessage.settings.restricted.body":
    "Súbory cookie používané na prihlásenie, objednávanie, analýzy a prispôsobené ponuky.",
  "CookieMessage.settings.highly_restricted.title": "Prísne obmedzené",
  "CookieMessage.settings.highly_restricted.body":
    "Povolené iba minimálne množstvo súborov cookie. Používa sa výhradne na prihlásenie, objednávanie a umožňuje fungovanie webu v primeranom rozsahu.",
  "CookieMessage.settings.options.title": "Tu je to, čo robíme:",
  "CookieMessage.settings.option.1":
    "Využitie súborov cookie na zaistenie správneho fungovania webu",
  "CookieMessage.settings.option.2": "Sledovanie anonymných štatistík",
  "CookieMessage.settings.option.3": "Výskum správania sa používateľov",
  "CookieMessage.settings.option.4":
    "Zobrazovanie informácií, ktoré by Vás mohli zaujímať",
  "CookieMessage.settings.option.5": "Sledovanie osobných štatistík",
  "CookieMessage.settings.option.6": "Používanie informácií pre našu reklamu",
  "CookieMessage.settings.option.7": "Zdieľanie Vašich osobných údajov",
  "CookieMessage.settings.title": "Nastavenie súborov cookie",
  "CookiePage.url": "ochrana-osobnych-udajov-cookies",
};
